import React, { PropTypes } from "react";
import styles from "components/manage-categories/add-category-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const DeleteCustomTabModal = ({
  customTabRemoveId,
  isDeleteCustomTabLoading,
  isDeleteCustomTabMode,
  onDeleteCustomTab,
  onEndDeleteCustomTabMode
}) => (
  <Modal
    isVisible={ isDeleteCustomTabMode }
    onClose={ onEndDeleteCustomTabMode }
    transitionName="add-category"
  >
    <h2>Are you sure you want to delete this tab?</h2>
    <div className={ styles["button-container"] }>
      <Button link onClick={ onEndDeleteCustomTabMode }>cancel</Button>
      <Button
        danger
        loading={ isDeleteCustomTabLoading }
        onClick={ () => onDeleteCustomTab(customTabRemoveId) }
      >
        Delete
      </Button>
    </div>
  </Modal>
  );

DeleteCustomTabModal.defaultProps = {
  customTabRemoveId: null
};

DeleteCustomTabModal.propTypes = {
  customTabRemoveId: PropTypes.string,
  isDeleteCustomTabLoading: PropTypes.bool.isRequired,
  isDeleteCustomTabMode: PropTypes.bool.isRequired,
  onDeleteCustomTab: PropTypes.func.isRequired,
  onEndDeleteCustomTabMode: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/delete-custom-tab-modal.jsx